import React from "react";
import { Route, Redirect } from "react-router-dom";
import Path from "../enums/path";

const AuthRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return localStorage.getItem("accessToken") ? (
          <Redirect to={`${Path.Slash}`} />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
};

export default AuthRoute;
